import * as DataDogLogs from '~/lib/datadog/datadog';

/**
 * Parses variants data to find the correct variant ID
 * Matches variant by title and colorway product ID
 *
 * @param {string} variantsData - JSON string of variants array
 * @param {string} selectedVariantTitle - The variant title to match (e.g., "8")
 * @param {string|number} selectedColorwayId - The colorway product ID to match
 * @returns {number|null} The matching variant ID or null if not found
 */
export function parseVariantId(variantsData, selectedVariantTitle, selectedColorwayId) {
  if (!variantsData) return null;

  try {
    const variants = JSON.parse(variantsData);

    if (!Array.isArray(variants)) return null;

    // Convert selectedColorwayId to number for comparison since variant.product_id is a number
    const colorwayIdNumber = parseInt(selectedColorwayId, 10);

    const matchingVariant = variants.find(
      (variant) =>
        variant.title === selectedVariantTitle && variant.product_id === colorwayIdNumber,
    );

    return matchingVariant?.id || null;
  } catch (error) {
    DataDogLogs.error(
      '[Allbirds utils] - variant-utils - parseVariantId - Error parsing variants data',
      { variantsData },
      error,
    );
    return null;
  }
}
